import { s } from "@kosmod/pancake";
import { define } from "./define";

export const doorLogic = define("door", s.o({
  open: s.bool
}));
